module.exports = __webpack_public_path__ + "img/us.29ec6187.svg";